import axios from 'axios';
import Util from './Util';
import { appEnv } from './tenant';

class Authentication {

    constructor () {
        this.nrtmApiEndpoint = process.env.VUE_APP_NRTM_API_HOST;
        // 会社コードはアクセスしたホスト名から判定する（SPEC-039）
        this.companyCd = appEnv.VUE_APP_COMPANY_CD;
    }

    combineUrl(parent,child){
        return Util.combineUrl(parent, child);
    }

    async httpPost(endpoint, data) {
        const response = await axios.post(endpoint, data);
        return response ? response.data : null;
    }

    _saveSession(ses) {
        const idToken = ses.idToken;
        const accessToken = ses.accessToken;
        const refreshToken = ses.refreshToken;

        localStorage.setItem('nrtm_id', JSON.stringify(idToken));
        localStorage.setItem('nrtm_access', JSON.stringify(accessToken));
        localStorage.setItem('nrtm_refresh', JSON.stringify(refreshToken));
    }

    _getToken(key) {
        const s = localStorage.getItem(key);
        if (!s) return null;
        const token = JSON.parse(s);
        const expiresAtMs = Date.parse(token.expiresAt);
        if (!Number.isFinite(expiresAtMs) || expiresAtMs <= Date.now()) {
            return null;
        }
        return token;
    }

    _getAccessToken() {
        return this._getToken('nrtm_access');
    }

    _getIdToken() {
        return this._getToken('nrtm_id');
    }

    _getRefreshToken() {
        return this._getToken('nrtm_refresh');
    }

    _getSession() {
        return {
            idToken: this._getIdToken(),
            accessToken: this._getAccessToken(),
            refreshToken: this._getRefreshToken(),
        };
    }

    _buildAuthResult(session) {
        const accessToken = session.accessToken;
        const payload = accessToken ? accessToken.payload : {};
        const tokenValue = accessToken ? accessToken.jwtToken : "";
        return {
            user_name: payload ? payload["noritama:userId"] : "",
            staff_cd: payload ? payload["noritama:staffCd"] : "",
            email: payload ? payload["email"] : "",
            email_verified: payload ? payload["email_verified"] : false,
            idToken: tokenValue ? "Bearer " + tokenValue : "",
            accessTokenJwt: tokenValue,
            rawSession: session,
        };
    }

    async _refreshSession() {
        const refreshToken = this._getRefreshToken();
        if (!refreshToken) return null;

        const path = "/auth/" + this.companyCd + "/refresh";
        const endpoint = this.combineUrl(this.nrtmApiEndpoint, path);
        const body = {
            userId: refreshToken.userId,
            refreshToken: refreshToken.token,
        };

        const ses = await this.httpPost(endpoint, body);
        if (!ses) return null;
        this._saveSession(ses);
        return this._getSession();
    }

    async checkLogin() {
        const accessToken = this._getAccessToken();
        if (accessToken) {
            return this._buildAuthResult(this._getSession());
        }
        const refreshed = await this._refreshSession();
        if (refreshed && refreshed.accessToken) {
            return this._buildAuthResult(refreshed);
        }
        throw new Error("not authenticated");
    }

    async signIn(username, password) {
        const body = {
            userId: username,
            password: password,
        };

        const path = "/auth/" + this.companyCd + "/signin";
        const endpoint = this.combineUrl(this.nrtmApiEndpoint, path);
        const ses = await this.httpPost(endpoint, body);
        if (!ses) return null;
        this._saveSession(ses);
        return this._buildAuthResult(this._getSession());
    }

    signOut() {
        localStorage.removeItem('nrtm_id');
        localStorage.removeItem('nrtm_access');
        localStorage.removeItem('nrtm_refresh');
        return Promise.resolve();
    }

    async changePassword(currentPass,newPass){
        const accessToken = this._getAccessToken();
        if (!accessToken || !accessToken.payload) {
            throw new Error("not authenticated");
        }
        const userId = accessToken.payload["noritama:userId"];
        const path = "/user/" + this.companyCd + "/" + userId + "/changepass";
        const endpoint = this.combineUrl(this.nrtmApiEndpoint, path);
        const data = {
            password: newPass,
        };
        return await this.httpPost(endpoint, data);
    }
}

let _aws = new Authentication();

export default _aws;
